import { render, staticRenderFns } from "./SBPagetop.html?vue&type=template&id=22d29664&scoped=true&"
import script from "./SBPagetop.ts?vue&type=script&lang=ts&"
export * from "./SBPagetop.ts?vue&type=script&lang=ts&"
import style0 from "./SBPagetop.css?vue&type=style&index=0&id=22d29664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d29664",
  null
  
)

export default component.exports